<p>
  location-create works!
</p>
